/**
 * Event name that CollapsibleCard listens for so a card can be opened from
 * outside its own tree. `revealManagementSection` used to be here too, wired
 * to the platform-wide "Look" button — deleted per G-7 of the 2026-09-15
 * rebuild spec, so the helper and its scroll math went with it. Keep the
 * event constant: CollapsibleCard still reads it, and a future ticket that
 * needs cross-tree opening (without teleporting the operator) can dispatch
 * it directly.
 */

export const OPEN_SECTION_EVENT = 'ga-mgmt-open-section';
